import { NavLink } from 'react-router-dom';
import { Home, Users, Video, Settings, Plus, UserPlus } from 'lucide-react';
import { clsx } from 'clsx';
import OctopusLogo from '../common/OctopusLogo';

const navigation = [
  { name: 'Dashboard', href: '/admin', icon: Home },
  { name: 'Personas', href: '/admin/personas', icon: Users },
  { name: 'Projects', href: '/admin/projects', icon: Video },
  { name: 'Beta Users', href: '/admin/beta-users', icon: UserPlus },
  { name: 'Settings', href: '/admin/settings', icon: Settings },
];

export default function Sidebar() {
  return (
    <aside className="hidden lg:fixed lg:inset-y-0 lg:flex lg:w-64 lg:flex-col">
      <div className="flex flex-col flex-grow bg-zinc-900 border-r border-zinc-800">
        {/* Logo */}
        <div className="flex items-center h-16 px-6 border-b border-zinc-800">
          <OctopusLogo />
          <span className="ml-2 text-xl font-bold gradient-text">Jellybop</span>
        </div>

        {/* Navigation */}
        <nav className="flex-1 px-4 py-4 space-y-1">
          {navigation.map((item) => (
            <NavLink
              key={item.name}
              to={item.href}
              className={({ isActive }) =>
                clsx(
                  'flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-medium transition-colors',
                  isActive ? 'bg-jelly-600/20 text-jelly-400' : 'text-zinc-400 hover:bg-zinc-800 hover:text-zinc-200'
                )
              }
            >
              <item.icon className="w-5 h-5" />
              {item.name}
            </NavLink>
          ))}
        </nav>

        {/* Quick action */}
        <div className="p-4 border-t border-zinc-800">
          <NavLink
            to="/admin/personas/new"
            className="flex items-center justify-center gap-2 w-full px-4 py-2 bg-jelly-600 hover:bg-jelly-500 text-white rounded-lg font-medium transition-colors"
          >
            <Plus className="w-4 h-4" />
            New Persona
          </NavLink>
        </div>

        {/* Footer */}
        <div className="p-4 text-xs text-zinc-500">
          <p>Jellybop v0.1.0</p>
          <p className="mt-1">AI-powered music videos</p>
        </div>
      </div>
    </aside>
  );
}
